export const buildMarkdownFromAsset = asset => {
  const fileName = asset?.file_name || '';
  const publicUrl = asset?.public_url || '';
  const altText = fileName ? fileName.replace(/\.[^/.]+$/, '').trim() : '';

  return `![${altText || 'image'}](${publicUrl})`;
};
